// context/AriaContext/actions.ts
import { 
  AriaAction,
  AnimationType,
  ErrorState,
  Message,
  VoiceState
} from '@/types';

export const ariaActions = {
  setActive: (isActive: boolean): AriaAction => ({
    type: 'SET_ACTIVE',
    payload: isActive
  }),

  setMinimized: (isMinimized: boolean): AriaAction => ({
    type: 'SET_MINIMIZED',
    payload: isMinimized
  }),

  setVoiceState: (state: Partial<VoiceState>): AriaAction => ({
    type: 'SET_VOICE_STATE',
    payload: state
  }),

  setVoiceEnabled: (enabled: boolean): AriaAction => ({
    type: 'SET_VOICE_ENABLED',
    payload: enabled
  }),

  setVolume: (volume: number): AriaAction => ({
    type: 'SET_VOLUME',
    payload: Math.max(0, Math.min(1, volume))
  }),

  setAnimationState: (state: AnimationType): AriaAction => ({
    type: 'SET_ANIMATION',
    payload: state
  }),

  setError: (error: ErrorState | null): AriaAction => ({
    type: 'SET_ERROR',
    payload: error
  }),

  addMessage: (message: Message): AriaAction => ({
    type: 'ADD_MESSAGE',
    payload: message
  })
};

export const createAsyncAction = async <T,>(
  action: Promise<T>,
  dispatch: React.Dispatch<AriaAction>
): Promise<T> => {
  try {
    dispatch(ariaActions.setAnimationState('thinking'));
    const result = await action;
    return result;
  } catch (error) {
    dispatch(ariaActions.setError({
      code: 'ASYNC_ACTION_ERROR',
      message: error instanceof Error ? error.message : 'Unknown error',
      recoverable: true
    }));
    throw error;
  } finally {
    dispatch(ariaActions.setAnimationState('idle'));
  }
};